<div class="trial-link-form">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-12">
        <label for="firstName" translate
          >sales.trial-link.form.firstName.label</label
        >
        <div
          class="vox-input-group vox-input-group_dense"
          [ngClass]="{ 'vox-input-group_invalid': isControlInvalid('name') }"
        >
          <input
            class="vox-text-field"
            type="text"
            id="firstName"
            placeholder="{{
              'sales.trial-link.form.firstName.placeholder' | translate
            }}"
            formControlName="name"
          />
          <i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"
          ></i>
          <span class="vox-input-group__error-message" translate
            >sales.trial-link.form.error</span
          >
        </div>
      </div>
      <div class="col-sm-12">
        <label for="email" translate>sales.trial-link.form.email.label</label>
        <div
          class="vox-input-group vox-input-group_dense"
          [ngClass]="{ 'vox-input-group_invalid': isControlInvalid('email') }"
        >
          <input
            class="vox-text-field"
            type="email"
            id="email"
            placeholder="john@smith.com"
            formControlName="email"
          />
          <i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"
          ></i>
          <span
            *ngIf="getFormControl('email').errors?.required"
            class="vox-input-group__error-message"
            translate
            >sales.trial-link.form.error</span
          >
          <span
            *ngIf="getFormControl('email').errors?.pattern"
            class="vox-input-group__error-message"
            translate
            >sales.trial-link.form.email.error</span
          >
        </div>
      </div>
      <div class="col-sm-12">
        <label for="country" translate
          >sales.trial-link.form.country.label</label
        >
        <vox-select-country
          [language]="language$ | async"
          [searchEnabled]="false"
          [countryList]="countries"
          [dense]="true"
          formControlName="country"
        >
        </vox-select-country>
      </div>
      <div class="col-sm-12">
        <div class="link-label-container">
          <label for="deal" translate
            >sales.trial-link.form.hubspot-deal-id.label</label
          >
          <button
            class="vox-btn link-btn"
            tabindex="-1"
            type="button"
            (click)="openDealIdModal()"
            translate
          >
            sales.trial-link.form.hubspot-deal-id.link
          </button>
        </div>
        <div
          class="vox-input-group vox-input-group_dense"
          [ngClass]="{ 'vox-input-group_invalid': isControlInvalid('deal_id') }"
        >
          <input
            class="vox-text-field"
            type="text"
            id="deal"
            placeholder="{{
              'sales.trial-link.form.hubspot-deal-id.placeholder' | translate
            }}"
            formControlName="deal_id"
          />
          <i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"
          ></i>
          <span class="vox-input-group__error-message" translate
            >sales.trial-link.form.error</span
          >
        </div>
      </div>
      <div class="col-sm-12">
        <label for="sms" translate>sales.trial-link.form.sms.label</label>
        <div class="vox-input-group">
          <label class="vox-field-label">
            <input
              type="radio"
              class="vox-radio"
              [value]="true"
              (click)="getFormControl('sms').setValue(true)"
              formControlName="sms"
            />
            {{ "sales.trial-link.form.sms.yes" | translate }}
          </label>
          <label class="vox-field-label">
            <input
              type="radio"
              class="vox-radio"
              [value]="false"
              (click)="getFormControl('sms').setValue(false)"
              formControlName="sms"
            />
            {{ "sales.trial-link.form.sms.no" | translate }}
          </label>
        </div>
      </div>
      <div class="col-sm-12">
        <label for="date" translate>sales.trial-link.form.date.label</label>
        <div
          class="vox-input-group vox-input-group_dense"
          [ngClass]="{ 'vox-input-group_invalid': isControlInvalid('date') }"
        >
          <gdp-date-picker
            formControlName="date"
            [minDate]="startDay"
          ></gdp-date-picker>
          <span
            class="vox-input-group__error-message"
            *ngIf="getFormControl('date').errors?.required"
            translate
            >sales.trial-link.form.error</span
          >
          <span
            class="vox-input-group__error-message"
            *ngIf="getFormControl('date').errors?.ngbDate"
            translate
            >sales.trial-link.form.invalid-date-error</span
          >
        </div>
      </div>
    </div>
    <div class="submit-container">
      <button
        class="vox-btn vox-btn-primary"
        type="submit"
        [disabled]="form.invalid"
        (click)="onSubmit()"
        translate
      >
        sales.trial-link.form.button
      </button>
    </div>
  </form>
</div>
